import i18next from "i18next";

import translationsEn from "@data/i18n/en.json";
import translationsEs from "@data/i18n/es.json";



export function initI18n(debug = false) {
    // Use url param as first preferred language. Fall back to browser preference
    // if not specified.
    if ('URLSearchParams' in window) {
        const url = new URL(window.location.toString())
        let lang = url.searchParams.get("lang");

        if (!lang && navigator.language) {
            lang = navigator.language.split(/[-_]/)[0];
            url.searchParams.set("lang", lang);
            history.pushState(null, '', url);
        }
        if (lang)
            document.documentElement.lang = lang;
    }

    return i18next.init({
        lng: document.documentElement.lang,
        debug,
        resources: {
            en: { translation: translationsEn },
            es: { translation: translationsEs },
        },
    });
}